import { func, object } from 'prop-types';
import { path, update } from 'ramda';
import React from 'react';
import KeyboardArrowUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';
import KeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';

import ContentColumns from '../../components/ContentColumns';
import TextFieldArea from 'components/TextFieldArea';
import TextFieldBox from 'components/TextFieldBox';

import Canvas from '../../../Canvas';
import drawTexts from './DrawTexts/DrawTexts';
import { colors } from 'styles/provider';
import { TextInputArea } from './View.less';

const iconAreaStyle = {
  width: '2.5rem',
  height: 'auto',
  margin: '0 0rem 0 0.5rem',
  paddingTop: '0.7rem',
  cursor: 'pointer',
};
const iconStyle = {
  color: colors.clrSecondary,
  width: 'auto',
  height: 'auto',
};

const targetArray = ['clearlyWorseStatus', 'currentStatus', 'nearFutureTarget', 'betterStatus', 'clearlyBetterStatus'];

const View3 = (_, { fmString, formValues, onChange }) => {
  React.useEffect(() => {
    let changes = {};

    // Get selected statuses from previous view and select the next target from data
    const currentFatigueStatusSelected = path(['rehab7', 'currentFatigueStatusSelected'], formValues);
    const currentCognitionStatusSelected = path(['rehab7', 'currentCognitionStatusSelected'], formValues);

    const nextFatigueTargetIndex = targetArray.indexOf(currentFatigueStatusSelected) + 1;
    const nextFatigueTarget =
      nextFatigueTargetIndex <= targetArray.length - 1 ? targetArray[nextFatigueTargetIndex] : targetArray[4];

    const nextCognitionTargetIndex = targetArray.indexOf(currentCognitionStatusSelected) + 1;
    const nextCognitionTarget =
      nextCognitionTargetIndex <= targetArray.length - 1 ? targetArray[nextCognitionTargetIndex] : targetArray[4];

    // On mount copy previous values from previous sessions so they can be edited one more time
    const previousFatigueTarget = path(['rehab4', nextFatigueTarget], formValues);
    const currentFatigueTarget = path(['rehab7', 'targetFatigue'], formValues);
    if (!currentFatigueTarget && previousFatigueTarget) {
      changes = { ...changes, targetFatigue: previousFatigueTarget };
    }
    const previousFatigueChanges = path(['rehab4', 'plannedChangesToManageFatigue'], formValues);
    const currentFatigueChanges = path(['rehab7', 'plannedChangesToManageFatigue'], formValues);
    if (!currentFatigueChanges && previousFatigueChanges) {
      changes = { ...changes, plannedChangesToManageFatigue: previousFatigueChanges };
    }
    // And cognition
    const previousCognitionTarget = path(['rehab6', nextCognitionTarget], formValues);
    const currentCognitionTarget = path(['rehab7', 'targetCognition'], formValues);
    if (!currentCognitionTarget && previousCognitionTarget) {
      changes = { ...changes, targetCognition: previousCognitionTarget };
    }
    const previousCognitionChanges = path(['rehab6', 'plannedChangesToManageCognitiveProblems'], formValues);
    const currentCognitionChanges = path(['rehab7', 'plannedChangesToManageCognitiveProblems'], formValues);
    if (!currentCognitionChanges && previousCognitionChanges) {
      changes = { ...changes, plannedChangesToManageCognitiveProblems: previousCognitionChanges };
    }

    if (Object.keys(changes).length > 0) {
      onChange(changes);
    }
  }, []);

  const plannedChangesToManageFatigue = path(['rehab7', 'plannedChangesToManageFatigue'], formValues);
  const plannedChangesToManageCognitiveProblems = path(
    ['rehab7', 'plannedChangesToManageCognitiveProblems'],
    formValues,
  );

  const targetFatigue = path(['rehab7', 'targetFatigue'], formValues);
  const targetCognition = path(['rehab7', 'targetCognition'], formValues);

  const draw = ctx => {
    // Draw background image
    const newImage = new Image();
    newImage.src = '/assets/images/roomboard-bg.png';
    newImage.onload = () => {
      ctx.drawImage(newImage, 0, 0, ctx.canvas.width, ctx.canvas.height);

      // Draw text elements and flags
      drawTexts(
        ctx,
        plannedChangesToManageFatigue,
        plannedChangesToManageCognitiveProblems,
        targetFatigue,
        targetCognition,
      );
    };
  };

  const onChangeText = name => event => {
    const eventValue = path(['currentTarget', 'value'], event);
    onChange({ [name]: eventValue });
  };

  const onChangeTextArray = (name, index) => event => {
    const allValues = path(['rehab7', name], formValues) || ['', '', ''];
    const eventValue = path(['currentTarget', 'value'], event);
    // Copy array so that changes dont roll backwards
    const allValuesMapped = allValues.map(a => a);
    allValuesMapped[index] = eventValue;
    onChange({ [name]: allValuesMapped });
  };

  const onChangeArrayIndexes = (name, index, direction) => {
    const array = path(['rehab7', name], formValues);
    const thisIndexValue = array[index];
    if (direction === 'up') {
      const toBeUpdatedValue = array[index - 1];
      let newArray = update(index - 1, thisIndexValue, array);
      newArray = update(index, toBeUpdatedValue, newArray);
      onChange({ [name]: newArray });
    }
    if (direction === 'down') {
      const toBeUpdatedValue = array[index + 1];
      let newArray = update(index + 1, thisIndexValue, array);
      newArray = update(index, toBeUpdatedValue, newArray);
      onChange({ [name]: newArray });
    }
  };

  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fmString('onlineRehabilitation.rehab7.3.header')}</h2>
            <br />
            <h3>{fmString('onlineRehabilitation.rehab7.3.fatigueTarget')}</h3>
            <TextFieldArea
              editing
              input={{
                name: 'targetFatigue',
                value: targetFatigue,
                onChange: onChangeText('targetFatigue'),
              }}
              cols={3}
              style={{ width: '27rem' }}
            />
            <br />
            <br />

            <h3>{fmString('onlineRehabilitation.rehab7.3.fatigueMeans')}</h3>
            {Array.isArray(plannedChangesToManageFatigue) &&
              plannedChangesToManageFatigue.map((c, i) => (
                <div
                  className={TextInputArea}
                  style={i === 4 ? { borderTop: '0.1rem solid black', marginTop: '1.5rem', paddingTop: '0.7rem' } : {}}
                >
                  <TextFieldBox
                    editing
                    input={{
                      name: 'plannedChangesToManageFatigue',
                      value: c,
                      onChange: onChangeTextArray('plannedChangesToManageFatigue', i),
                    }}
                    style={{ width: '27rem' }}
                  />
                  <div
                    style={iconAreaStyle}
                    onClick={i !== 0 ? () => onChangeArrayIndexes('plannedChangesToManageFatigue', i, 'up') : null}
                  >
                    {i !== 0 && <KeyboardArrowUp style={iconStyle} />}
                  </div>
                  <div
                    style={iconAreaStyle}
                    onClick={
                      i !== plannedChangesToManageFatigue.length - 1
                        ? () => onChangeArrayIndexes('plannedChangesToManageFatigue', i, 'down')
                        : null
                    }
                  >
                    {i !== plannedChangesToManageFatigue.length - 1 && <KeyboardArrowDown style={iconStyle} />}
                  </div>
                </div>
              ))}

            <br />
            <br />
            <h3>{fmString('onlineRehabilitation.rehab7.3.cognitionTarget')}</h3>
            <TextFieldArea
              editing
              input={{
                name: 'targetCognition',
                value: targetCognition,
                onChange: onChangeText('targetCognition'),
              }}
              cols={3}
              style={{ width: '27rem' }}
            />
            <br />
            <br />
            <h3>{fmString('onlineRehabilitation.rehab7.3.cognitionMeans')}</h3>
            {Array.isArray(plannedChangesToManageCognitiveProblems) &&
              plannedChangesToManageCognitiveProblems.map((c, i) => (
                <div
                  className={TextInputArea}
                  style={i === 4 ? { borderTop: '0.1rem solid black', marginTop: '1.5rem', paddingTop: '0.7rem' } : {}}
                >
                  <TextFieldBox
                    editing
                    input={{
                      name: 'plannedChangesToManageCognitiveProblems',
                      value: c,
                      onChange: onChangeTextArray('plannedChangesToManageCognitiveProblems', i),
                    }}
                    style={{ width: '27rem' }}
                  />
                  <div
                    style={iconAreaStyle}
                    onClick={
                      i !== 0 ? () => onChangeArrayIndexes('plannedChangesToManageCognitiveProblems', i, 'up') : null
                    }
                  >
                    {i !== 0 && <KeyboardArrowUp style={iconStyle} />}
                  </div>
                  <div
                    style={iconAreaStyle}
                    onClick={
                      i !== plannedChangesToManageCognitiveProblems.length - 1
                        ? () => onChangeArrayIndexes('plannedChangesToManageCognitiveProblems', i, 'down')
                        : null
                    }
                  >
                    {i !== plannedChangesToManageCognitiveProblems.length - 1 && (
                      <KeyboardArrowDown style={iconStyle} />
                    )}
                  </div>
                </div>
              ))}
          </div>
        }
        secondColumn={
          <div>
            <Canvas draw={draw} width="1470" height="1038" style={{ width: '100%', height: 'auto' }} />
          </div>
        }
        inverse
      />
    </React.Fragment>
  );
};

View3.contextTypes = {
  fmString: func,
  formValues: object,
  onChange: func,
};

export default View3;
